export class ClipboardItem {
  static STATUS_NEW = 'new';
  static STATUS_CREATING = 'creating';
  static STATUS_PERSISTED = 'persisted';

  constructor(id, status, contentType, contentUrl, createdAt) {
    this.id = id;
    this.status = status;
    this.contentType = contentType;
    this.contentUrl = contentUrl;
    this.createdAt = createdAt;
    this.raw = {}; // Default empty raw object
  }

  getType() {
    throw new Error(`Unsupported content type: ${this.contentType}`);
  }

  getCreatedAt() {
    return this.createdAt ? new Date(this.createdAt) : null;
  }

  getFormattedDate() {
    const date = this.getCreatedAt();
    return date ? date.toLocaleString() : 'Unknown date';
  }

  getTrashedAt() {
    return this.raw?.trashed_at || null;
  }

  get trashedAt() {
    return this.getTrashedAt();
  }

  get pinned() {
    return this.raw?.pinned ?? false;
  }

  get pinnedAt() {
    return this.raw?.pinned_at || null;
  }
}

export default ClipboardItem;
